<template minapp="mpx" xlang="wxml">
  <view class="guide-wrap" wx:if="{{list.length}}">
    <block wx:for="{{list}}">
      <view class="item">
        <image src="{{icon}}" class="icon"/>
        <view class="title">{{item}}</view>
      </view>
    </block>

  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props:{
      list:{
        type: Array,
        value:[]
      }
    },
    data: {
      icon:'https://ut-static.udache.com/webx/sfc/hJS6wjGQFvCMkNZB3UMu1.png',
    },
    computed: {
    },
    methods: {
    }
  })
</script>

<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .guide-wrap
    background linear-gradient(0deg, #EAF3FF, #EAF3FF), #FFFFFF
    box-sizing border-box
    border 1.5px solid #FFFFFF
    display flex
    align-items center
    border-radius 8px 8px 0 0
    padding 4px 20px 4px 20px
    height 38px
    justify-content space-around
    .item
      display flex
      flex-direction row
      align-items center
      &:first-child
        margin-left 0
      .icon
        width: 8px;
        height: 7.5px; 
        margin-right: 6px;
      
      .title
        font-family: PingFang SC;
        font-size: 12px;
        font-weight: normal;
        line-height: 12px;
        letter-spacing: 0px;
        color: #2776A8;


</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>